define(['jquery', 'common', 'erv_tracking', 'erv_pricebreakdown'],
	function ($, ERVCommon, ERVTracking, ERVPriceBreakdown) {
		var ERVBooking = function() {
			var self = this;
			self.$ervBody = $('#erv-body');
			self.common = new ERVCommon();
			self.tracking = new ERVTracking();
			self.priceBreakdown = new ERVPriceBreakdown();
		};

		ERVBooking.prototype.init = function() {
			var self = this,
				$bookingContainer = self.$ervBody.find('.booking');

			if (window.history && self.common.framework.checks.isCriOs()) {
				window.history.pushState({ 'criosfix: ': true }, null, window.location.pathname);
			}

			if ($bookingContainer.length > 0) {
				self.$ervBody.find('.next-step').on('click', function (e) {
					e.preventDefault();

					var $form = $(this).parents('form');
					if (!$form.valid()) {
						e.stopPropagation();
						return;
					}

					self.common.forms.activateLoading($(this), false);
					var submit = function () { $form.submit(); }

					if ($bookingContainer.is('.bookingpaymentpage')) {
						self.tracking.trackEvent('BookingInvoiceVsCardVsGiro', 'Selected', self.$ervBody.find('[data-js="paymentmethod"] input:checked').val(), null, submit);
					} else if ($bookingContainer.is('.bookingcontactdetailspage')) {
						var $renewal = self.$ervBody.find('[data-js="yestorenewal"]');
						if ($renewal && $renewal.length && $renewal.prop('checked')) {
							self.tracking.trackEvent('Booking', 'PBS Enable', 'Total price: ' + $bookingContainer.find('[data-totalprice]').data('totalprice'), null, submit);
						} else {
							submit();
						}
					} else {
						submit();
					}
				});

				self.priceBreakdown.init();
			}

			self.common.forms.validationSummary.setErrorFieldLabels();

			self.$ervBody.find('.choice label').on('click', function (e) {
				var $this = $(this),
					$parent = $this.parents('.choice'),
					$choiceContainer = $parent.parents('.choice-container');

				if ($choiceContainer.length === 1) {
					$choiceContainer.find('.active').removeClass('active');
				}
				$parent.toggleClass('active');

				if ($parent.hasClass('annual-upgrade')) {
					var $form = $this.parents('form');

					if (!$form.valid()) {
						e.preventDefault();
						e.stopPropagation();

						return;
					}

					self.$ervBody.find('[data-js="trigger-annual-upgrade"]').click();
				}
			});

			$('body').trigger('bookingjsloaded');
		}

	return ERVBooking;
});